exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginform[data-v-0582493a]{min-height:290px;width:350px;padding:24px;background:#546ff9;background:-webkit-linear-gradient(top left,#455ac5,#31287d);background:-moz-linear-gradient(top left,#455ac5,#31287d);background:linear-gradient(to bottom right,#455ac5,#31287d);margin:1rem 0 2rem;color:#eee}.loginhero[data-v-0582493a]{min-height:100px;max-width:420px;color:#555}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0582493a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Login.vue
// module id = 637
// module chunks = 0